<template>
  <div class="About">
    <h1>Hello {{ their_name }}, this is an about page</h1>
    <p>This webpage is made with Vue.JS a front-end JavaScript web framework. Vue is a approachable, versatile, performant  frame-work which helps you maintain a more code pace.
    </p>
    <p>Vue is a progressive framework, you can plug it into a part of your application, that needs a richer, more interctive experience. </p>
    <p>The advantage with Vue.js is that it enables development of large scale templates. Which not only makes it easier for programmers but also saves a lot of time. Due to its uncomplicated structure very less time is spent on searching blocks containing errors.</p>
   <br><br><br> 
  
    <div class="column">
    <img src="https://cdn-images-1.medium.com/max/1600/1*wqYF-8Dmh7LhtLkKfERc3Q.png" alt="vue" style="width:85%">
  </div>
  <div class="column">
    <img src="http://searchlite.nl/wp-content/uploads/2016/08/JavaScript.png" alt="js" style="width:85%">
  </div>
  <div class="guide">
   <h1>Guide</h1>
    <p> Let's start off by making a Hello World Example! </p>
    <p>Because of this framework you can see live-changes if you add or delete text in the html, what makes it really easy and fast to see the direct changes which take place.<br><br>Directives are prefixed with v- to indicate that they are special attributes provided by Vue, and as you may have guessed, they apply special reactive behavior to the rendered DOM. Type in after message: 'Hello World!' </p>
    <p> 
<img src="https://i.gyazo.com/8c8b6aa71794f17e4d1fe123b1cc40ab.png" alt="js" style="width:50%">
</p>
    <p>
      <p>By using the v-model here it is basically saying “keep this element’s title attribute up-to-date with the message property on the Vue instance.” Inside the input field you can change it to anything you'd like and the changes will directly take place.</p>
      <img src="https://i.gyazo.com/dbff455b3c06c033f1f6888a6ecd6bf3.png" alt="js" style="width:50%">

    <p>Next, lets render a list, just use the V-directive again to make a list, inside this list you "echo"it again so it will be actively changed inside the script. Making lists in Vue.js is really easy, you could even make them in the Script, add the following 3 items to you list as seen below: 'Learn JavaScript' , 'Learn Vue.js' and 'Build something awesome' and voila, you just made an list in Vue.</p>
    <p>
      <img src="https://i.gyazo.com/78486393b978ffaee449e12a10564de8.png" alt="js" style="width:50%">
    </p>
    <p></p>
    <p></p>
  </div>  
</div>
  
</template>

<script>
export default {
  name: 'Skills',
  data() {
    return {
      their_name: this.$route.params.name
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,700');
@import url('https://fonts.googleapis.com/css?family=Yantramanav:100');
body {
  background-color: #EEEEEE;
  font-family: 'Montserrat', sans-serif;
  display: grid;
  grid-template-rows: auto;
  justify-items: center;
  /* padding-top: 50px; */
}
body, html {
  margin: 0;
  height: 100%;
}

h1{
  
  font-family: 'Yantramanav', sans-serif;
  font-size: 150%;
  font-weight: 100;
  color: #f1fff9;
}

.About{ 
  margin-top: 5%;
  font-family: 'Yantramanav', sans-serif;
  font-size: 150%;
  font-weight: 100;
  color: #f1fff9;
}
#app {
    width: 50%;
}

/* nav {
  padding: 20px 20px 20px 0;
}

nav a {
  padding: 10px;
  text-decoration: none;
  background: #fff;
  border-radius: 3px;
  color: rgb(0, 110, 255);
  font-weight: bold;
  margin-right: 15px;
} */
.column {
  float: left;
  width: 50%;
  padding: 5px;
}

/* Clear floats after image containers */
.row::after {
  content: "";
  clear: both;
  display: table;
}
.class{
  padding-top: 500px;
  margin-bottom: 500px;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue